import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'
import createStyles from './styles'

export class Image extends React.PureComponent {
  render() {
    const { source, style, ...props } = this.props
    const styles = getStyles(props, this.context)

    return (
      <img alt="" {...props} src={source} className={css(styles.root, style)} />
    )
  }
}

Image.contextTypes = {
  theme: PropTypes.object,
}

Image.propTypes = {
  source: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alignment: PropTypes.string,
}

const getStyles = createStyles(props => ({
  root: {
    display: props.alignment === 'center' ? 'block' : 'inline-block',
    height: props.height,
    width: props.width,
    margin: props.alignment === 'center' ? '0 auto 35px auto' : '0',
  },
}))



// WEBPACK FOOTER //
// ./src/components/Image.js